import { BlobUpperCorner, BlobUpperCornerMobile } from '@icons/Blobs';
import FadeInSection from '../FadeInSection';
import { SliderCarousel } from 'components/SliderCarousel';
import NextImage from '../NextImage';
import { ImagesService } from 'service/images/imagesService';

import {
  TopRightCornerAsset,
  TopRightCornerBlob,
  TopRightCornerBlobMobile,
  BackgroundWrapper,
  TextWrapper,
  GlobalStyle,
} from './styles';

export interface ITips {
  Title?: string;
  Text?: string;
  bannerSize?: string;
}

const DesktopSVG = ({ backgroundAsset, id }: { backgroundAsset: string; id: string }) => (
  <svg
    viewBox="0 0 1440 473"
    preserveAspectRatio="none"
    height="100%"
    width="100%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id={`${id}-desktop-mask`}>
        <path
          d="M0.5 425.631V47.369C0.638282 47.3493 0.809842 47.3249 1.01441 47.2959C1.64085 47.2072 2.57679 47.0755 3.81436 46.9037C6.28951 46.56 9.97118 46.056 14.7964 45.4144C24.4468 44.1313 38.6712 42.2981 56.9659 40.0983C93.5554 35.6986 146.425 29.8322 211.545 23.9657C341.785 12.2328 521.019 0.5 717 0.5C912.981 0.5 1093.72 12.2328 1225.46 23.9658C1291.33 29.8322 1344.95 35.6987 1382.1 40.0984C1400.67 42.2982 1415.13 44.1314 1424.95 45.4145C1429.85 46.0561 1433.6 46.5602 1436.12 46.9038C1437.38 47.0756 1438.33 47.2074 1438.97 47.2961C1439.18 47.3255 1439.36 47.3503 1439.5 47.3701V425.63C1439.36 425.65 1439.18 425.674 1438.97 425.704C1438.33 425.793 1437.38 425.924 1436.12 426.096C1433.6 426.44 1429.85 426.944 1424.95 427.585C1415.13 428.869 1400.67 430.702 1382.1 432.902C1344.95 437.301 1291.33 443.168 1225.46 449.034C1093.72 460.767 912.981 472.5 717 472.5C521.019 472.5 341.785 460.767 211.545 449.034C146.425 443.168 93.5554 437.301 56.9659 432.902C38.6712 430.702 24.4468 428.869 14.7964 427.586C9.97118 426.944 6.28951 426.44 3.81436 426.096C2.57679 425.925 1.64085 425.793 1.01441 425.704C0.809842 425.675 0.638282 425.651 0.5 425.631Z"
          fill="#FA85BD"
        />{' '}
      </clipPath>
    </defs>
    <image
      height="473"
      width="1440"
      preserveAspectRatio="xMidYMid slice"
      xlinkHref={ImagesService.getImageUrlWithCompressionParams(
        backgroundAsset ?? '',
        70,
        1440,
        undefined,
        false,
      )}
      clipPath={`url(#${id}-desktop-mask)`}
    />
  </svg>
);

const MobileSVG = ({ backgroundAsset, id }: { backgroundAsset: string; id: string }) => (
  <svg
    viewBox="0 0 320 326"
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id={`${id}-mobile-mask`}>
        <path
          d="M0.5 314.247V10.8642C0.612089 10.8485 0.745899 10.8298 0.901115 10.8082C1.45043 10.732 2.26783 10.6201 3.33934 10.4776C5.48235 10.1926 8.64174 9.78548 12.7055 9.29683C20.8331 8.31953 32.5782 7.01631 47.0449 5.71304C75.979 3.10644 115.797 0.5 159.333 0.5C202.87 0.5 243.021 3.10645 272.289 5.71309C286.922 7.01637 298.834 8.31961 307.087 9.29694C311.213 9.7856 314.425 10.1928 316.604 10.4777C317.694 10.6202 318.526 10.7321 319.085 10.8084C319.246 10.8304 319.385 10.8494 319.5 10.8653V314.246C319.385 314.262 319.246 314.281 319.085 314.303C318.526 314.379 317.694 314.491 316.604 314.633C314.425 314.918 311.213 315.326 307.087 315.814C298.834 316.792 286.922 318.095 272.289 319.398C243.021 322.005 202.87 324.611 159.333 324.611C115.797 324.611 75.979 322.005 47.0449 319.398C32.5782 318.095 20.8331 316.792 12.7055 315.814C8.64174 315.326 5.48235 314.918 3.33934 314.634C2.26783 314.491 1.45043 314.379 0.901115 314.303C0.745899 314.281 0.612089 314.263 0.5 314.247Z"
          fill="#FA85BD"
        />{' '}
      </clipPath>
    </defs>
    <image
      height="326"
      width="320"
      preserveAspectRatio="xMidYMid slice"
      xlinkHref={ImagesService.getImageUrlWithCompressionParams(
        backgroundAsset ?? '',
        70,
        320,
        undefined,
        true,
      )}
      clipPath={`url(#${id}-mobile-mask)`}
    />
  </svg>
);

const metaballs = (upperRightCorner: any) => (
  <>
    <TopRightCornerBlob className="hidden md:block">
      <FadeInSection delay="1200ms" bounce>
        <BlobUpperCorner />
      </FadeInSection>
    </TopRightCornerBlob>
    <TopRightCornerBlobMobile className="block md:hidden">
      <FadeInSection delay="1200ms" bounce fadeIn>
        <BlobUpperCornerMobile />
      </FadeInSection>
    </TopRightCornerBlobMobile>
    <TopRightCornerAsset data-test="top-right-picture">
      <FadeInSection delay="700ms">
        <NextImage sources={ImagesService.getPictureSources(upperRightCorner)} alt="" />
      </FadeInSection>
    </TopRightCornerAsset>
  </>
);

export const RecipeTips = ({
  data,
  backgroundAsset,
  upperRightCorner,
  recipeTipsTitle,
  watchVideoLabel = '',
}: {
  data: ITips[];
  backgroundAsset: Record<string, string>;
  upperRightCorner: Record<string, string>;
  recipeTipsTitle: string;
  watchVideoLabel?: string;
}) => {
  const componentName = `${backgroundAsset?.background}-recipe-tips`;
  return (
    <div
      className="relative overflow-hidden pt-20 md:pt-40 pb-20 md:pb-0"
      data-test={componentName}
    >
      <FadeInSection delay="400ms">
        <div className="h-fit hidden md:block">
          <BackgroundWrapper data-test={`${componentName}-background-wrapper-desktop`}>
            <DesktopSVG backgroundAsset={backgroundAsset?.background} id={componentName} />
          </BackgroundWrapper>
        </div>
        <div className="block md:hidden">
          <BackgroundWrapper data-test={`${componentName}-background-wrapper-mobile`}>
            <MobileSVG backgroundAsset={backgroundAsset?.background} id={componentName} />
          </BackgroundWrapper>
        </div>
        <GlobalStyle />
        <TextWrapper>
          {metaballs(upperRightCorner)}
          <SliderCarousel
            tips={data}
            type="text"
            customStyle="flex justify-center flex-col h-fit relative z-10"
            recipeTipsTitle={recipeTipsTitle}
            dotsOnTop={-50}
            isOverflowHidden={false}
            watchVideoLabel={watchVideoLabel}
          />
        </TextWrapper>
      </FadeInSection>
    </div>
  );
};
